import * as svg from "../../../assets/chain.svg";

import {iconBuilder} from "./iconBuilder";

export const ChainIcon = iconBuilder(svg, "ChainIcon", "0 0 12 12");
